import { useEffect, useState } from 'react'
import { getPlanSnapshot, isPlanExpired, listPlansForAthlete, type Plan, type PlanDaySnapshot } from './api'
import { findResumableWorkout, startPlanWorkout } from '../workouts/api'

export function PlanTrainingLauncher(props: {
  athleteId: string
  onOpenWorkout: (sessionId: string) => void
}) {
  const [plans, setPlans] = useState<Plan[]>([])
  const [days, setDays] = useState<Record<string, PlanDaySnapshot[]>>({})
  const [resumable, setResumable] = useState<{ id: string; name: string } | null>(null)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function load() {
    const [loadedPlans, active] = await Promise.all([
      listPlansForAthlete(props.athleteId),
      findResumableWorkout(props.athleteId),
    ])
    setPlans(loadedPlans)
    setResumable(active ? { id: active.id, name: active.name } : null)
    const entries = await Promise.all(loadedPlans.filter((plan) => plan.status === 'active').map(async (plan) => [plan.id, (await getPlanSnapshot(plan)).days] as const))
    setDays(Object.fromEntries(entries))
  }

  useEffect(() => { void load().catch((e) => setError(e instanceof Error ? e.message : 'Pläne konnten nicht geladen werden.')) }, [props.athleteId])

  async function start(plan: Plan, day: PlanDaySnapshot, dayIndex: number) {
    setBusy(true)
    setError(null)
    try {
      const session = await startPlanWorkout({ athleteId: props.athleteId, plan, day, dayIndex })
      props.onOpenWorkout(session.id)
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Training konnte nicht gestartet werden.')
    } finally { setBusy(false) }
  }

  const activePlans = plans.filter((plan) => plan.status === 'active')

  return <>
    {error && <p className="error card">{error}</p>}
    {resumable && <section className="card resume-card"><p className="eyebrow">FORTSETZEN</p><h2>{resumable.name}</h2><button onClick={() => props.onOpenWorkout(resumable.id)}>Training fortsetzen</button></section>}
    {activePlans.length === 0 && <section className="card"><p className="eyebrow">TRAININGSPLAN</p><h2>Noch kein aktiver Plan</h2><p>Es ist aktuell kein aktiver Trainingsplan hinterlegt.</p></section>}
    {activePlans.map((plan) => <section className="card" key={plan.id}>
      <div className="plan-heading"><div><p className="eyebrow">TRAININGSPLAN</p><h2>{plan.name}</h2></div>{isPlanExpired(plan) && <span className="status-pill">Beendet</span>}</div>
      {isPlanExpired(plan) && <p>Die geplante Laufzeit ist beendet. Der Plan bleibt weiterhin nutzbar.</p>}
      <div className="day-list">
        {(days[plan.id] ?? []).map((day, index) => <button className="day-button" disabled={busy} key={day.id ?? index} onClick={() => void start(plan, day, index)}><span>{day.name || `Training ${index + 1}`}</span><small>{day.exercises?.length ?? 0} Übungen</small></button>)}
      </div>
    </section>)}
  </>
}
